enum SkyBoxRoutesEnum {
  //Calendar Presets
  CALENDAR_PRESETS = "global/calendar-presets",

  //Users
  USER_DETAILS = "user/details",

  //User Management
  USER_CREATE_OR_UPDATE = "user-management/create-user",
  USER_AUTH0_DETAIL = "user-management/user-auth0-details",
  USER_RESEND_INVITE = "user-management/user-resend-invite",
  USER_LIST = "user-management/user-list",
  USER_DELETE = "user-management/delete",

  //Commissions
  BROKER_TAG_DETAILS = "/skybox/commissions/broker-tag-details",
  BROKER_TAGS_COMMISSION_UPDATE = "/skybox/commissions/update-broker-tag-commissions",

  //Reports dashboard
  DASHBOARD_CATEGORY_LIST = "skybox/reports/category",
  ADD_REMOVE_FAVORITES = "skybox/reports/add-remove-favorite",

  //Filter Options
  BROKER_TAGS_BY_REPORT_ID = "skybox/reports/broker-tags-by-report-id",
  BUYER_LIST = "skybox/reports/buyer-details",
  SHIPPER_LIST = "skybox/reports/shipper-details",
  EVENT_LIST = "skybox/reports/event-details",
  VENUE_LIST = "skybox/reports/venue-details",
  DATE_RANGE = "skybox/reports/date-ranges",
  CARD_LIST = "skybox/reports/card-details",
  ALERT_LIST = "skybox/reports/alert-details",
  CURRENCY_LIST = "skybox/reports/currency-details",
  REPORT_LIST = "skybox/reports/report-details",
  RECIPIENT_LIST = "skybox/reports/recipient-details",
  SALE_CATEGORY_LIST = "skybox/reports/sale-category-details",
  CUSTOMER_CLASSIFICATION_LIST = "skybox/reports/customer-classification-details",
  STATE_LIST = "skybox/reports/all-states",
  INVENTORY_CANCELLATION_TYPE_LIST = "skybox/reports/all-inventory-cancellation-types",
  SEAT_INTELLIGENCE_DETAILS = "skybox/reports/seat-intelligence-details",
  BROKER_USER_LIST = "skybox/reports/broker-list",
  BUYER_USER_LIST = "skybox/reports/buyer-list",
  LISTER_USER_LIST = "skybox/reports/lister-list",
  SEAT_MAP_CREATOR_USER_LIST = "skybox/reports/seat-map-creator-list",
  CHECKER_USER_LIST = "skybox/reports/checker-list",
  VENUE_DATE_PRESETS = 'skybox/reports/venues-date-presets',
  // LISTER_USER_BY_BROKER = "skybox/reports/lister-list-by-broker",
  BROKER_TEAM_BY_BROKER = "skybox/reports/broker-team-by-broker-id",
  AGING_PERIODS_LIST = "skybox/reports/get-all-aging-periods",
  FULFILLMENT_STATUSES_LIST = "skybox/reports/get-all-fulfillment-statuses",
  SHOW_CATEGORIES = "skybox/filters/show-categories",
  SCRAPING_STATUS_DETAILS = "skybox/reports/scraping-status-details",
  VENUE_SCRAPING_TYPES = "/skybox/filters/venue-scraping-type",

  // Profitability Reports
  GROSS_PROFIT = "skybox/reports/gross-profit",
  GROSS_PROFIT_CANCELLED = "skybox/reports/gross-profit-cancelled",
  PROFIT_DASHBOARD_SCORE = "skybox/reports/profit-dashboard/score",
  PROFIT_DASHBOARD_BROKER_SUMMARY = "skybox/reports/profit-dashboard/broker-summary",
  PROFIT_DASHBOARD_GROSSPROFIT_GRAPH = "skybox/reports/profit-dashboard/grossprofit-graphdata",
  PROFIT_DASHBOARD_BROKER_COMMISSION_GRAPH = "skybox/reports/profit-dashboard/brokercommission-graphdata",
  PROFIT_DASHBOARD_GROSSPROFIT_PERIOD_BREAKUP = "skybox/reports/profit-dashboard/grossprofit-period-breakup",
  PROFIT_DASHBOARD_GROSSPROFIT_BROKER_COMMISSION_PERIOD_BREAKUP = "skybox/reports/profit-dashboard/grossprofit-broker-commission-period-breakup",
  PROFIT_DASHBOARD_TOP_EVENTS = "skybox/reports/profit-dashboard/profit-dashboard-top-events",
  BROKER_TAG_ISSUES = "skybox/reports/broker-tags-issues",
  CONSIGNMENT_SALES = "skybox/reports/consignment-sales",
  SHORTS_PENDING = "skybox/reports/orders-pending-delivery",
  CONSIGNMENT_PENDING_BUY_IN = "skybox/reports/consignment-pending-buy-in",
  INVOICES_NEEDING_ATTENTION = "skybox/reports/invoices-needing-attention",
  RECEIVABLES_DETAILS = "skybox/reports/gross-profit/receivables-wholesale-consignments",
  RECEIVABLES_RETAIL = "skybox/reports/gross-profit/receivables-retail",
  RECEIVABLES_DETAILS_OLD = "skybox/reports/gross-profit/receivables-wholesale-consignments-old",
  RECEIVABLES_RETAIL_OLD = "skybox/reports/gross-profit/receivables-retail-old",
  ACTIVE_ZONE_LISTING = "skybox/reports/active-zone-listing",
  OTHER_COSTS_AND_CREDITS = "skybox/reports/gross-profit/other-costs-and-credits",

  SOLD_INVENTORY_ISSUE_RESOLUTION = "skybox/reports/save_sold_inventory_resolve_issue",

  LONG_INVENTORY = "skybox/reports/inventory/long",
  LONG_INVENTORY_NOT_LISTED = "skybox/reports/inventory/long/not-listed",
  LONG_INVENTORY_SCORECARD = "skybox/reports/scorecard",
  SKYBOX_USER_LIST = "skybox/reports/skybox-user-details",
  SKYBOX_VENDORS = "skybox/reports/skybox-vendors",
  ROLE_LIST = "skybox/reports/role-details",
  SPLIT_TYPE_LIST = "skybox/reports/split-type-details",
  BUYER_TAG_LIST = "skybox/reports/buyer-tag-details",
  LISTER_TAG_LIST = "skybox/reports/lister-tag-details",
  TICKETBASH_BROKER_LIST = "skybox/reports/ticketbash-broker-details",
  PRICING_RESOLUTIONS = "/skybox/reports/resolve-pricing-master",
  SAVE_PRICING_RESOLUTIONS = "/skybox/reports/save_long_rpt_resolve_pricing_issue",

  //Schedule
  CREATE_SCHEDULE = "skybox/scheduler/create",
  GET_SCHEDULE_LIST = "skybox/scheduler/schedule-list",
  GET_SCHEDULE_BY_ID = "skybox/scheduler/schedule-by-id",
  GET_SCHEDULE_RECIPIENTS = "skybox/scheduler/recipients",
  TOGGLE_SCHEDULE_STATUS = "skybox/scheduler/toggle-status",
  DELETE_SCHEDULE = "skybox/scheduler/delete-schedule",
  FORCE_RUN_SCHEDULE = "skybox/scheduler/force-run",

  
  LOG = "log",

  //Venue
  VENUE_DETAILS = "skybox/venue/details",
  VENUE_ADD_REMOVE_FAVORITES = "skybox/venue/add-remove-favorites",
  VENUE_EDIT = "skybox/venue/edit",
  VENUE_BULK_ASSIGN_BROKER = "skybox/venue/bulk-assign-venues",
  VENUE_BUYER_LIST = "skybox/venue/buyer-list/{venue_id}",

  //Event
  EVENT_DETAILS = "skybox/event/details",

  //Event Metadata
  EVENT_METADATA = "skybox/event/metadata",
  EVENT_METADATA_AUDIT_HISTORY = "skybox/event/metadata-audit-history",
  EVENT_METADATA_TREND_DATA = "skybox/event/zone-trend",
  EVENT_METADATA_SAVE = "skybox/event/metadata",
  EVENT_LIST_FOR_COPY_DOWN_METADATA = "skybox/event/get-events-for-copy-down-metadata/{event_id}",
  EVENT_SAVE_COPY_DOWN_METADATA = "skybox/event/save-copy-down-metadata/{event_id}",
  SEAT_MAP_TBD_DROPDOWN_DATA = "/skybox/event/seat-map-tbd-dropdown-data",
  EVENT_REFRESH_MVW = "skybox/event/refresh-mvw-for-upcoming-events",
  SPLIT_METADATA = "skybox/event/save-split-metadata",

  //Event Create New Zone Listing
  EVENT_METADATA_FOR_NEW_ZONE_LISTING = "skybox/event/metadata-for-create-zone-listing",

  //Housekeeping
  ACTIVE_INVENTORY = "skybox/inventory/active",
  SOLD_INVENTORY = "skybox/inventory/sold",
  SOLD_INVENTORY_LIST_ITEM = "skybox/inventory/sold-item",
  UNFILLED_ZONES = "skybox/inventory/unfilled-zones",
  UNFILLED_ZONE_LIST_ITEM = "skybox/inventory/unfilled-zone-item/",
  CANCEL_INVENTORY = "skybox/cancel-inventory",
  CANCEL_INVOICE = "skybox/cancel-invoice",
  CANCELLED_INVENTORY = "skybox/inventory/cancelled-inventory",
  VENUES_WITH_UNMAPPED_EVENT = "skybox/event-mapping/venues",
  EVENTS_FOR_MAPPING = "skybox/event-mapping/get-events-for-mapping",
  UPDATE_SCRAPING_EVENTS = "skybox/event-mapping/map-events",

  //Zones
  ZONE_DETAILS_BY_ID = "skybox/zones/zone-details-for-zone-listing",
  ZONE_CREATE_NEW_LISTING = "skybox/zones/create-listing/{event_id}",
  ZONE_REFRESH_MVW_FOR_PURCHASE = "skybox/zones/purchase/refresh-mvw-for-purchase",
  ZONE_LISTING_DETAILS_BY_EVENT = "/skybox/zones/zone-listing-details-by-event",
  ZONE_ACTIVE_LISTINGS_BY_EVENT = "/skybox/zones/active-listings-by-event",
  ZONE_FORCE_UPDATE_PURCHASE = "skybox/zones/purchase/force-update/{purchase_id}",
  ZONE_FORCE_UPDATE_REFRESHED_MVW_CONFIG = "/skybox/zones/update-configuration-master-refreshing-mvw-off",
  // All Zone Listings
  ZONE_ALL_ZONE_LISTINGS = "/skybox/zones/events-with-active-zone-listings",
  HIGH_RISK_LISTINGS= "/skybox/zones/get-high-risk-listings",
  ZONE_HIGH_RISK_LISTINGS = "/skybox/zones/events-with-high-risk-listings",
  // Pending Fills
  ZONE_PENDING_ZONE_FILLS = "/skybox/zones/get-pending-zone-fills-listings",
  ZONE_PAYMENT_STATUS_LIST = "/skybox/zones/get-all-payment-statuses",
  ZONE_ACTIVE_LISTINGS_UPDATE_BROADCAST_STATUS = "/skybox/zones/active-listings-update-broadcast-status/{inventory_id}",
  ZONE_ACTIVE_LISTINGS_UPDATE_AUTO_PRICE_ADJUSTMENT_STATUS = "/skybox/zones/update-auto-adjustment-status/{inventory_id}",
  ZONE_INVENTORY_FORCE_SYNCED = "/skybox/zones/zone-inventory/force-synced",
  ZONE_GET_EVENTS_CREATE_LISTING_BULK_PLACEMENT = "/skybox/zones/get-events-create-listing-bulk-placement",
  ZONE_ACTIVE_LISTING_CANCEL = "/skybox/zones/active-listing-cancel/purchases/{purchase_id}/lines/{line_id}",
  ZONE_PENDING_ZONE_FILLS_PURCHASE_ASSIGNMENT = "/skybox/zones/pending-fills-zone-assignment",
  ZONE_ACTIVE_LISTINGS_SPLIT_INVENTORY = "/skybox/zones/zone-inventory/split-inventory/{inventory_id}/{numberOfTickets}",
  ZONE_PURCHASE_LINE_FORCE_SYNCED = "/skybox/zones/purchase/line/force-update/{purchase_line_id}",
  ZONE_PENDING_ZONE_FILLS_SAVE_PURCHASE_ASSIGNMENT = "/skybox/zones/save-purchase-assignments",
  // Split Inventory Data
  ZONE_GET_SPLIT_INVENTORY_DATA = "/skybox/zones/get-split-inventory-data",
  // Edit Listing
  ZONE_LISTING_UPDATE_SECTION_ROW_PRICE = "/skybox/zones/edit-listing-section-row-price",
  ZONE_FORCE_UPDATE_INVENTORIES = "/skybox/zones/force-update-platform-skybox-inventories",
  ZONE_BULK_UPDATE_BROADCAST_STATUS = "/skybox/zones/bulk-update-listing-broadcast-status",

  // Remap Listing with Zone
  ZONE_REMAP_LISTING_WITH_ZONE = "/skybox/zones/remap-listings-with-zones",

  
  // Dashboard
  DASHBOARD_LISTER_ALERTS_NEW_SHOWS_COUNT = "skybox/dashboard/lister/alerts/new-shows-count",
  DASHBOARD_LISTER_INSIGHTS_EVENTS_COUNT = "skybox/dashboard/lister/insights/events-count",
  DASHBOARD_LISTER_INSIGHTS_VENUES_COUNT = "skybox/dashboard/lister/insights/venues-count",
  DASHBOARD_LISTER_KPIS_NEW_LISTINGS_GRAPH = "skybox/dashboard/lister/kpis/new-listings",
  DASHBOARD_LISTER_INSIGHTS_ZONE_LISTINGS_COUNT = "skybox/dashboard/lister/insights/zone-listings-count",
  DASHBOARD_LISTER_NEW_SHOWS_NO_LISTING_DATA = "skybox/dashboard/lister/all-events-data",
  DASHBOARD_LISTER_UN_BROADCASTS_GRAPH = "skybox/dashboard/lister/kpis/un-broadcasts",
  DASHBOARD_LISTER_SALES_OVER_TIME_GRAPH = "skybox/dashboard/lister/kpis/sales-over-time",

  DASHBOARD_CHECKER_SEAT_AVAILABILITY = "skybox/dashboard/checker/seat-availability",
  DASHBOARD_CHECKER_KPIS_SEAT_AVAILABILITY_UPDATE_GRAPH = "skybox/dashboard/checker/kpis/seat-availability-update-over-time",
  DASHBOARD_CHECKER_ALERTS_NEW_SHOWS_COUNT = "skybox/dashboard/checker/alerts/shows-count",

  DASHBOARD_SEAT_MAP_CREATOR_ALERTS_SHOWS_COUNT = "skybox/dashboard/seat-map-creator/alerts/shows-count",
  DASHBOARD_SEAT_MAP_CREATOR_SEAT_STRUCTURE_DATA = "skybox/dashboard/seat-map-creator/seat-structure-data",
  DASHBOARD_SEATMAP_SEATING_STRUCTURE_CREATED_GRAPH = "skybox/dashboard/seat-map-creator/kpis/seating-structure-created",

  DASHBOARD_OPERATIONS_ALERTS_HIGH_RISK_LISTINGS = "skybox/dashboard/operations/get-high-risk-listings",
  DASHBOARD_OPERATIONS_PENDING_FILLS_ALERTS_COUNTS = "skybox/dashboard/operations/get-pending-zone-fills-widget-counts",
  DASHBOARD_OPERATIONS_PENDING_FILLS_ALERTS_SALES = "skybox/dashboard/operations/get-pending-zone-fills-widget-sales",
  DASHBOARD_OPERATIONS_PENDING_FILLS_ALERTS_BROKERS = "skybox/dashboard/operations/get-pending-zone-fills-widget-brokers",
  DASHBOARD_BOT_PERFORMANCE_DATA = "/skybox/bot-performance-data",
  
  DASHBOARD_PERFORMANCE_ANALYSIS_CREATED_SECTIONS = "skybox/dashboard/performance-analysis/created-sections",
  DASHBOARD_PERFORMANCE_ANALYSIS_CHECKED_SECTIONS = "skybox/dashboard/performance-analysis/checked-sections",
  DASHBOARD_PERFORMANCE_ANALYSIS_UPDATED_GA_EVENTS_SECTIONS = "skybox/dashboard/performance-analysis/updated-ga-events",
  DASHBOARD_PERFORMANCE_ANALYSIS_SPLIT_INFO = "skybox/dashboard/performance-analysis/split-count",
  DASHBOARD_PERFORMANCE_ANALYSIS_VENUE_ASSIGNMENT_INFO = "skybox/dashboard/performance-analysis/venue-assignment",
  DASHBOARD_PERFORMANCE_ANALYSIS_LISTED_EVENTS_INFO = "skybox/dashboard/performance-analysis/listed-events",
  DASHBOARD_PERFORMANCE_ANALYSIS_LISTED_SECTIONS_INFO = "skybox/dashboard/performance-analysis/listed-sections",
  DASHBOARD_PERFORMANCE_ANALYSIS_LISTED_GA_EVENTS_INFO = "skybox/dashboard/performance-analysis/listed-ga-events",
  DASHBOARD_PERFORMANCE_ANALYSIS_LISTER_CONVERSION_RATE_INFO = "skybox/dashboard/performance-analysis/lister-conversion-rate",
  DASHBOARD_PERFORMANCE_ANALYSIS_LISTER_MARGIN_OF_PRICING_INFO = "skybox/dashboard/performance-analysis/lister-margin-of-pricing",

  // Purchase Queue
  PURCHASE_QUEUE_MASTER_DATA = "skybox/queue/purchase/purchase-queue-master-data",
  PURCHASE_QUEUE_INVOICE_DETAIL_MODAL_DATA = "skybox/queue/purchase/get-invoice-detail-modal-data",
  PURCHASE_QUEUE_GET_SWIMLANE_MASTER_LIST = "skybox/queue/purchase/get-purchase-swimlane-master-data",
  PURCHASE_QUEUE_GET_SWIMLANE_INVOICE_LIST = "skybox/queue/purchase/get-purchase-swimlane-invoice-list",
  PURCHASE_QUEUE_MOVE_TO_ON_SALE = "skybox/queue/purchase/move-to-onsale",
  PURCHASE_QUEUE_MOVE_TO_PURCHASED = "skybox/queue/purchase/move-to-purchased",
  PURCHASE_QUEUE_MOVE_TO_NEED_TO_BUY = "skybox/queue/purchase/move-to-need-to-buy",
  PURCHASE_QUEUE_MOVE_TO_NEED_TO_BUY_LOW_PRIORITY = "skybox/queue/purchase/move-to-need-to-buy-low-priority",
  PURCHASE_QUEUE_MOVE_TO_ADD_NOTES = "skybox/queue/purchase/add-notes",
  PURCHASE_QUEUE_CHANGE_BUYER = "skybox/queue/purchase/change-buyer",
  PURCHASE_QUEUE_MOVE_TO_ISSUES = "skybox/queue/purchase/move-to-issues",
  PURCHASE_QUEUE_GET_KEBAB_MENU_OPTIONS = "skybox/queue/purchase/get-purchase-queue-menu-options",
  PURCHASE_QUEUE_CHANGE_PRIORITY = "skybox/queue/purchase/change-priority",
  PURCHASE_QUEUE_MOVE_TO_SHIPPING = "skybox/queue/purchase/move-to-shipping",
  PURCHASE_QUEUE_GET_AUDIT_HISTORY = "skybox/queue/purchase/audit-history/{invoice_id}",
  PURCHASE_QUEUE_GET_NOTES_HISTORY = "skybox/queue/purchase/notes-history/{invoice_id}",
  PURCHASE_QUEUE_SAVE_ISSUE_REMINDER = "skybox/queue/purchase/set-issue-reminder",
  PURCHASE_QUEUE_UPDATE_ISSUE = "skybox/queue/purchase/update-issue",
  PURCHASE_QUEUE_CLOSE_ISSUE = "skybox/queue/purchase/close-issue",
  PURCHASE_QUEUE_CHANGE_ONSALE_STATUS = "skybox/queue/purchase/change-onsale-status",
  PURCHASE_QUEUE_SAVE_ONSALE_REMINDER = "skybox/queue/purchase/set-onsale-reminder",

  //Shipping Queue
  SHIPPING_QUEUE_MOVE_TO_ISSUES = "skybox/queue/shipping/move-to-issues",
  SHIPPING_QUEUE_CLOSE_ISSUE = "skybox/queue/shipping/close-issue",
  SHIPPING_QUEUE_MOVE_TO_ADD_NOTES = "skybox/queue/shipping/add-notes",
  SHIPPING_QUEUE_CHANGE_SHIPPER = "skybox/queue/shipping/change-shipper",
  SHIPPING_QUEUE_UPDATE_ISSUE = "skybox/queue/shipping/update-issue",
  SHIPPING_QUEUE_MARK_AS_DELIVERED = "skybox/queue/shipping/mark-as-delivered",
  SHIPPING_QUEUE_MARK_AS_NOT_DELIVERED = "skybox/queue/shipping/mark-as-not-delivered",
  SHIPPING_QUEUE_MOVE_TO_SELL_OUT = "skybox/queue/shipping/move-to-sell-out",
  DELIVERED_TICKETS = "/skybox/delivered-tickets",

  //Competitor Prices
  COMPETITOR_PRICES = "/skybox/competitor-prices",
  SECONDARY_MARKETPLACE_MASTER = "/skybox/competitor-prices/secondary-marketplace-master",
}

export { SkyBoxRoutesEnum };
